import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { IconButton } from '@/components/icon-button/IconButton'
import { MenuContent, MenuItemGroup } from '@/components/menu/MenuContent'
import { MenuItem } from '@/components/menu/MenuItem'
import { OverflowMenu, Edit, MoveToFolder, TrashDelete, FileDownload } from '@/assets/icons'

interface FileOverflowMenuProps {
  /** On download */
  onDownload?: () => void
  /** Optional rename functionality */
  onRename?: () => void
  /** On delete */
  onDelete?: () => void
  /** On move */
  onMove?: () => void
  /** Disable the menu */
  disabled?: boolean
}

/**
 * FileOverflowMenu
 *
 * Dropdown menu for file actions (download, rename, move, delete).
 */
export function FileOverflowMenu({ onDownload, onRename, onDelete, onMove, disabled = false }: FileOverflowMenuProps) {
  const hasActions = Boolean(onDownload || onRename || onDelete || onMove)

  if (!hasActions) {
    return null
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger disabled={disabled} asChild>
        <IconButton icon={<OverflowMenu />} variant="plain" color="neutral" aria-label="File actions" disabled={disabled} />
      </DropdownMenu.Trigger>

      <MenuContent align="end" alignOffset={-3} side="bottom">
        <MenuItemGroup>
          {onDelete && <MenuItem label="Delete" icon={TrashDelete} onSelect={onDelete} variant="destructive" />}
          {onRename && <MenuItem label="Rename" icon={Edit} onSelect={onRename} variant="neutral" />}
          {onDownload && <MenuItem label="Download" icon={FileDownload} onSelect={onDownload} variant="neutral" />}
          {onMove && <MenuItem label="Move" icon={MoveToFolder} onSelect={onMove} variant="neutral" />}
        </MenuItemGroup>
      </MenuContent>
    </DropdownMenu.Root>
  )
}
